(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');
    const collectionWrapper = document.querySelector('.collection-wrapper');

    if (facetsTop && sortWrapper && collectionWrapper) {
      collectionWrapper.style.gridTemplateRows = sortWrapper.getBoundingClientRect().height + 'px auto 1fr';
    }
  }

  const resizeCollectionGrid = () => {
    const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

    const sectionResizeObserver = new ResizeObserver((entries) => {

      const [entry] = entries;
      calcMinHeight();
    });

    sectionResizeObserver.observe(collectionGridSection);
  }

  const initStickyFacets = () => {
    const facetsContainer = document.querySelector('.facets-container');
    if (!facetsContainer) return;

    let isSticky = false;
    let rafId = null;

    const checkSticky = () => {
      const rect = facetsContainer.getBoundingClientRect();
      const isHeaderSticky = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--is-header-sticky')) === 1;
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

      const expectedTop = isHeaderSticky ? headerHeight : 0;
      const tolerance = 1; // Allow 1px tolerance for subpixel rendering
      const shouldBeSticky = Math.abs(rect.top - expectedTop) <= tolerance && rect.top <= expectedTop + tolerance;

      if (shouldBeSticky && !isSticky) {
        facetsContainer.classList.add('is-sticky');
        isSticky = true;
      } else if (!shouldBeSticky && isSticky) {
        facetsContainer.classList.remove('is-sticky');
        isSticky = false;
      }
    };

    const handleScroll = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        checkSticky();
        rafId = null;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    checkSticky();
  };

  document.addEventListener('shopify:section:load', function () {
    resizeCollectionGrid();
    initStickyFacets();
  });

  resizeCollectionGrid();
  initStickyFacets();


})();